export default __webpack_public_path__ + "static/sr-f679a4d6ab3759e5b8dfbc7154a62237.gif";